import React from 'react';

const ColorRoundCheckmark = (props) => {
  return(
    <svg className={ props.className } width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
      <g>
        <path fill="#00DC86" d="M10,19 C5.0375,19 1,14.9625 1,10 C1,5.0375 5.0375,1 10,1 C14.9625,1 19,5.0375 19,10 C19,14.9625 14.9625,19 10,19 L10,19 Z M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 L10,0 Z"></path>
        <path fill="#00DC86" d="M7.71703098,14.382924 L4.11700098,10.782894 C3.96099967,10.6268927 3.96099967,10.3736906 4.11700098,10.2172893 C4.27340228,10.060888 4.52660439,10.060888 4.68260569,10.2172893 L7.99983333,13.534517 L15.3170943,6.21725598 C15.4734956,6.06085467 15.7266977,6.06085467 15.882699,6.21725598 C16.0391003,6.37365728 16.0391003,6.62685939 15.882699,6.78286069 L11.1557589,11.5098009 C10.1980511,12.4675086 8.28263569,14.382924 8.28263569,14.382924 C8.20463504,14.4609247 8.10223419,14.500125 7.99983333,14.500125 C7.89783248,14.500125 7.79543163,14.4609247 7.71703098,14.382924 Z"></path>
      </g>
    </svg>
  )
};

export default ColorRoundCheckmark;
